import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component,OnDestroy, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from "@ngxs/store";
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor, State, orderBy } from '@progress/kendo-data-query';
import { CopyDossier, ResetState, SetDossier } from "app/_actions/intake.actions";
import { DOSSIER_STATUS } from 'app/_constants/dossierStatus';
import { ROLES } from 'app/_constants/roles';
import { ClientVm } from 'app/_mapper/client.vm';
import { CaseModel } from 'app/_models';
import { DossierModel } from 'app/_models/Dossier.model';
import { CallBackModel } from 'app/_models/call-back.model';
import { CaseType } from 'app/_models/case-type/add-edit-case-type.model';
import { ClientPolicyControlExceptionModel } from 'app/_models/clientpolicycontrolexception.model';
import { DeathDetailModel } from 'app/_models/death-detail.model';
import { DiagnoseModel } from 'app/_models/diagnose.model';
import { GeneralModel } from 'app/_models/general.model';
import { intakeTimeValueModel } from 'app/_models/intakeTimeValue.model';
import { SummaryDetailsModel } from 'app/_models/summary-details.model';
import { AuthenticationService } from 'app/_services';
import { DateService } from 'app/_services/date.service';
import { IntakeState } from 'app/_state/intake.state';
import { IntakeMapperService } from 'app/intake/intake-mapper.service';
import { IntakeService } from 'app/intake/intake-services/intake.service';
import { HelpPlanService } from 'app/management/Templates/help-plan.service';
import { CommonService } from 'app/reusable/common.service';
import { CedConfirmDialogService, CedNotificationService } from 'ced-ng-library';
import { environment } from "environments/environment";
import { Observable, Subject } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from '../../_services/shared.service';
import { CaseTypelistComponent } from '../case-type-list/case-type-list.component';
import { dossierColumns } from './dossier-columns';
import { CASE_TYPE } from 'app/_constants/caseDetails';
import * as moment from 'moment';

@Component({
  selector: 'app-dossier-list',
  templateUrl: './dossier-list.component.html',
  styleUrls: ['./dossier-list.component.scss']
})
export class DossierListComponent implements OnInit, OnDestroy {
  dataSource: any;
  @Select(IntakeState.getIntake) Intake$: Observable<any>;
  dossier: DossierModel;
  private _subject$: Subject<boolean> = new Subject();
  intakeTimeValue = new intakeTimeValueModel();
  selectedDossier;
  editMode: boolean = false;
  isDossierLoading: boolean = false;
  isHV: boolean = false;
  public isloading: boolean = false;
  newCaseType: CaseType = null;
  caseDetail;
  isFilterApplied: boolean = false;
  public state: DataStateChangeEvent = {
    skip: 0,
    take: 20,
    filter: {
      logic: 'and',
      filters: [],
    },
    sort: [
      {
        field: null,
        dir: null,
      }
    ]
  };

  public columns: any;
  public dossierActions: any;
  public reservedActionBy: any = [];
  public hasIntakeCreationPermission: boolean = false;
  public serverUrlSlot2 : string = environment.Services.AlphaURLSlot2;
  public serverUrlSlot1 : string = environment.Services.AlphaURLSlot1;
  public isDisplayed = false;
  contactWith = [];
  isVecozoCheck: boolean = false;
  isPiaCheck: boolean = false;
  selectedClientInException = new ClientPolicyControlExceptionModel();
  mainRoute ='../dashboard/home'

  constructor(
    private commonService: CommonService,
    private store: Store, private sharedService: SharedService,
    private intakeService: IntakeService,
    private authenticationService: AuthenticationService,
    private cedNotificationService: CedNotificationService,
    public translate: TranslateService,
    private intakeMapperService: IntakeMapperService,
    private cedConfirmService: CedConfirmDialogService,
    private dialogService: DialogService,
    private dateService: DateService,
    private cd: ChangeDetectorRef,
    private helpPlanService : HelpPlanService
  ) {  }
  ngOnInit() {

    this.subscribeToSearchFilter()
    this.subscribeToMainRouter()
    this.getRoles();
    this.hasIntakeCreationPermission = this.sharedService.checkPermissionByRole("Intake").hasCreate;

    if(!this.isFilterApplied){
       this.getDossier();
   }
    this.getIntakeDuration();
    this.initColumns();
  }
  subscribeToSearchFilter(): void {
    this.sharedService.searchDossierListFilter$
      .pipe(takeUntil(this._subject$))
      .subscribe({
        next: (filter) => {
          if(filter)
            this.state = filter;
            this.isFilterApplied = true;
            this.dataStateChange(this.state);
        },
        complete: () => {this.sharedService.setSearchFilter(this.state)}
      });
  }
  subscribeToMainRouter(): void {
    this.sharedService.mainRoute$
      .pipe(takeUntil(this._subject$))
      .subscribe({
        next: (route) => {
          if(route)
           {
            this.mainRoute= ".."+route
          }
        }});
  }

  getRoles() {
    let roles = this.authenticationService.getLocalStorageRoles();
    if (roles != null){
      this.editMode = roles.find(r => r.authorizationRoleId.trim() == ROLES.DOSSIER_MANAGEMENT && r.operationUpdate == true) != undefined;
      let copyRoles = [ROLES.SENIOR_HULPVERLENER, ROLES.SOS_TEAM_MANAGER ,ROLES.ADMINISTRATORS, ROLES.BEGINNER_MEDICAL_ASSISTANT, ROLES.INTERMEDIATE_MEDICAL_ASSISTANT, ROLES.ADVANCED_MEDICAL_ASSISTANT];
      this.isHV = roles.some(r => copyRoles.indexOf(r.authorizationGroupRoleId) >= 0);
    }
  }

  getDossier() {
    this.isloading = true;
    let GetDossierUrl: string = 'Dossier/GetDossierGrid';
    const state = this.getState();
    this.commonService.create(GetDossierUrl, state).pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.dataSource = data;
        this.dataSource.data.forEach((element) => {
          element.birthDate = this.getLocaleDate(element.birthDate);
          element.creationDate =  moment(new Date(element.creationDate)).format('DD-MM-YYYY HH:mm');
          element.lastModificationDate = this.getLocaleDate(element.lastModificationDate);
          element.incidentDate = this.getLocaleDate(element.incidentDate);
          if(element.urgency == false){
          element.urgency = this.translate.instant("MANAGEMENT.USER_ACOUNTS_LIST.NO");
          }
          else{
            element.urgency = this.translate.instant("MANAGEMENT.USER_ACOUNTS_LIST.YES");
          }
        });
        this.isloading = false;
      },
        (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
        });
  }

  getLocaleDate(date: Date) {
    return this.intakeService.getLocalDate(date);
  }

  getIntakeDuration() {
    this.Intake$.pipe(takeUntil(this._subject$)).subscribe((res) => {
      if (res.intake.dossierId == null &&
        res.intake != null &&
        res.intake.intakeDuration != null) {
        let intakeDuration = res.intake.intakeDuration;
        let minutes = Math.floor(intakeDuration / 60);
        let displayMessage = this.translate.instant("NOTIFICATIONS.INTAKE_DURATION", { minutes: minutes, seconds: intakeDuration - (minutes * 60) });
        this.cedNotificationService.success(displayMessage);
      }
    });
  }

  getDataDiff(startDate, endDate) {
    var diff = endDate - startDate;
    var minutes = Math.floor(diff / (60 * 1000));
    var seconds = Math.floor(diff / 1000) - minutes * 60;
    return { minute: minutes, second: seconds };
  }
  openDetails(event, gridDossier) {
    let selectedData
    if (event.path) {
      selectedData = gridDossier.data.data[event.path[1].rowIndex];
      this.open(selectedData.dossierId, true)
    } else {
      selectedData = gridDossier.data.data[event.target.parentElement.rowIndex];
    }
  }
  open(dossierId, editMode) {
    if (this.isDossierLoading) return this.cedNotificationService.warning("NOTIFICATIONS.GET_LOADING");
    this.isDossierLoading = true;
    let GetDossierUrl: string = `Dossier/GetById/` + dossierId;
    this.commonService.getData(GetDossierUrl, this.serverUrlSlot2).pipe(takeUntil(this._subject$))
      .subscribe(
        (data: any) => {
          this.helpPlanService.getHelpPlansByDossierid(data.dossierId).pipe(takeUntil(this._subject$))
            .subscribe((res) => {
              data.helpPlans = res;
              this.store.dispatch(new SetDossier(data, editMode));
              this.isDossierLoading = false;
            })
        },
        (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
          this.isDossierLoading = false;
        });
  }

  startNewIntake() {
    this.store.dispatch(new ResetState()).pipe(takeUntil(this._subject$)).subscribe();
  }

  dblClickEvent() {
    if (this.selectedDossier != null)
      this.open(this.selectedDossier.dossierId, this.editMode);
    this.selectedDossier = null;
  }

  onCellClick($event) {
    this.selectedDossier = $event.dataItem
  }

  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getDossier();
  }

  getState() {
    const state = JSON.parse(JSON.stringify(this.state))
    state.filter.filters.forEach(x => {
      x["filters"].forEach(s => {
        if ( (s["field"].indexOf("birthDate") >= 0) || (s["field"].indexOf("lastModificationDate") >= 0) || (s["field"].indexOf("incidentDate") >= 0) ) {
          s["value"] = this.dateService.getLocalISODateFormat(s["value"]).toString();
        }
      })
    });
    return state;
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.state.sort = sort;
  }

  public copyDossier(dossierId) {
    this.GetContactWith();
    this.cedConfirmService
      .show("CONFIRM_CASETYPE_CHANGE?")
      .pipe(takeUntil(this._subject$))
      .subscribe((res) => {
        let getDossierUrl: string = `Dossier/GetById/` + dossierId;
        this.commonService.getData(getDossierUrl, this.serverUrlSlot2).pipe(takeUntil(this._subject$))
          .subscribe(
            (data: any) => {
              this.helpPlanService.getHelpPlansByDossierid(dossierId).pipe(takeUntil(this._subject$))
                .subscribe((result) => {
                  data.helpPlans = result;

                  if (!res.value) {
                    this.createCopy(data, res.value);
                  }
                  else {
                    const dialogRef = this.dialogService.open({
                      content: CaseTypelistComponent,
                      width: "700px"
                    });
                    dialogRef.content.instance.dossierId = data.dossierId;
                    dialogRef.result.subscribe(async (result: any) => {
                      if (!(result instanceof DialogCloseResult)) {
                        this.newCaseType = result;

                        let getCaseDetailURL = "CaseDetail/GetById/" + this.newCaseType.ctyCaseDetailId;
                        await this.commonService.getData(getCaseDetailURL, this.serverUrlSlot2).toPromise().then
                          ((data) => {
                            this.caseDetail = data;
                          });;

                        this.createCopy(data, res.value);
                      }
                    });
                  }
                })
            });
      },
        (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
        });
  }

  createCopy(originalDossier, changeCaseType) {
    let copiedIntake = this.intakeMapperService.dataFromApi(originalDossier);
    copiedIntake.intake.dossierId = null;
    copiedIntake.intake.policy.dossierNbr = null;
    copiedIntake.intake.draftDossierNumber = null;
    copiedIntake.intake.dossierStatus = DOSSIER_STATUS.OPEN;
    copiedIntake.intake.policy.showEmptyTravelInsuranceList = false;
    copiedIntake.intake.intakeDuration = null;
    copiedIntake.intake.originalDossierId = originalDossier.dossierId;
    copiedIntake.intake.helpPlans = [];
    copiedIntake.intake.isCopy = true;
    copiedIntake.intake.changeCaseType = changeCaseType;
    if (originalDossier.travel == null)
      copiedIntake.intake.travel = null;

    if (changeCaseType) {
      copiedIntake.intake.assignmentId = null;
      copiedIntake.intake.policy.isNoPolicycheck = false;
      copiedIntake.intake.policy.iagCorePartner = new ClientVm();
      copiedIntake.intake.policy.reason = "";
      if(this.newCaseType.ctyName == CASE_TYPE.OVERLIJDEN){
        copiedIntake.intake.policy.incidentDate = null;
      }
      else{
        copiedIntake.intake.policy.incidentDate = originalDossier.policy.incidentDate;
      }
      copiedIntake.intake.policy.location = originalDossier.policy.accidentLocation;
      copiedIntake.intake.policy.country = originalDossier.policy.country;
      let locations = copiedIntake.intake.policy.cause.locations;
      copiedIntake.intake.policy.cause = this.newCaseType;
      copiedIntake.intake.policy.cause.ctyCaseDetailId = this.newCaseType.ctyCaseDetailId;
      copiedIntake.intake.policy.cause.caseDetailLabel = this.newCaseType.caseDetailLabel;
      if (this.newCaseType.locations != null) {
        this.newCaseType.locations.forEach(element => {
          if (locations.find(e => e.lctName == element.lctName) != null) {
            element.locationDetails = locations.find(e => e.lctName == element.lctName).locationDetails;
          }
        });
      }
      copiedIntake.intake.policy.cause.locations = this.newCaseType.locations;
      copiedIntake.intake.case = new CaseModel();
      if (this.caseDetail.cdName == "Diagnoses") {
        copiedIntake.intake.case.diagnoseDetail = new DiagnoseModel();
      }
      if (this.caseDetail.cdName == "General") {
        copiedIntake.intake.case.general = new GeneralModel();
      }
      if (this.caseDetail.cdName == "Death") {
        copiedIntake.intake.case.death = new DeathDetailModel();
      }
      if (this.caseDetail.cdName == "Call back") {
        copiedIntake.intake.case.callBack = new CallBackModel();
      }
    }
    else {
      copiedIntake.intake.policy.cause.ctyDossierProductId = originalDossier.policy.caseType.ctyDossierProductId;
      copiedIntake.intake.policy.cause.ctyDossierAssignmentTypeId = originalDossier.policy.caseType.ctyDossierAssignmentTypeId;
      copiedIntake.intake.insuree = null;
      if (copiedIntake.intake.case.diagnoseDetail != null)
        copiedIntake.intake.case.diagnoseDetail = new DiagnoseModel();
      if (copiedIntake.intake.case.general != null)
        copiedIntake.intake.case.general = new GeneralModel();
      if (copiedIntake.intake.case.death != null)
        copiedIntake.intake.case.death = new DeathDetailModel();
      if (copiedIntake.intake.case.callBack != null)
        copiedIntake.intake.case.callBack = new CallBackModel();
    }
    copiedIntake.intake.summary = new SummaryDetailsModel();
    let _steps = copiedIntake.steps;

    if(copiedIntake.intake.insuree != null){
      let contactInitiation = this.contactWith.find(c => c.cwId == copiedIntake.intake.insuree.ipaContactWith);
      if (contactInitiation != undefined && (contactInitiation.cwName == "Patient" || contactInitiation.cwName == "Client")) {
        copiedIntake.intake.insuree.ipaContactTelephone = copiedIntake.intake.insuree.ipaPhoneNumber;
      }
    }
    if (copiedIntake.intake.policy.client) {
      let selectedPolicy = copiedIntake.intake.policy.cause.clientPolicyControlExceptions.filter((el) => el.cpcOrganizationunitId == copiedIntake.intake.policy.client.id)[0];
      if (selectedPolicy) {
        this.selectedClientInException = selectedPolicy;
        this.checkClientPolicy();
      } else {
        this.checkCausePolicy(this.newCaseType);
      }
    }
    if (this.isPiaCheck && this.isVecozoCheck) {
      copiedIntake.intake.policy.selectedhealthPolicies.forEach(element => {
        element.assignmentId = null
      });
      copiedIntake.intake.policy.selectedtravelPolicies.forEach(element => {
        element.assignmentId = null
      });
    }
    if (!this.isPiaCheck) {
      copiedIntake.intake.policy.selectedhealthPolicies.forEach(element => {
        element.assignmentId = null
      });
      copiedIntake.intake.policy.selectedtravelPolicies = [];
    }
    if (!this.isVecozoCheck) {
      copiedIntake.intake.policy.selectedhealthPolicies = [];
      copiedIntake.intake.policy.selectedtravelPolicies.forEach(element => {
        element.assignmentId = null
      });
    }
    copiedIntake.intake.userEmail = null;
    this.store.dispatch(new CopyDossier(copiedIntake, true));
  }

  checkClientPolicy() {
    if (this.selectedClientInException) {
      if (this.selectedClientInException.cpcCheckMethodId == "PIA") {
        this.isPiaCheck = true;
        this.isVecozoCheck = false;
      }
      else if (this.selectedClientInException.cpcCheckMethodId == "Vecozo") {
        this.isVecozoCheck = true;
        this.isPiaCheck = false;
      }
      else if (this.selectedClientInException.cpcCheckMethodId == "Both") {
        this.isPiaCheck = true;
        this.isVecozoCheck = true;
      }
    }
  }

  checkCausePolicy(caseType) {
    if (caseType) {
      if (caseType.ctyHasPiaPolicy && !caseType.ctyHasVecozoPolicy) {
        this.isPiaCheck = true;
        this.isVecozoCheck = false;
      }
      else if (caseType.ctyHasVecozoPolicy && !caseType.ctyHasPiaPolicy) {
        this.isVecozoCheck = true;
        this.isPiaCheck = false;
      }
      else if (caseType.ctyHasPiaPolicy && caseType.ctyHasVecozoPolicy) {
        this.isPiaCheck = true;
        this.isVecozoCheck = true;
      }
    }
  }

  GetContactWith() {
    let GetContactInitiationTypesUrl: string = `ContactInitiationType/GetAll`;
    let GetContactWithUrl: string = `ContactWith`;
    forkJoin([
      this.commonService.getData(GetContactInitiationTypesUrl, this.serverUrlSlot1,true),
      this.commonService.getData(GetContactWithUrl, this.serverUrlSlot1)]).pipe(takeUntil(this._subject$))
      .subscribe((results: any[]) => {
        this.contactWith = orderBy(results[1], [{ field: "cwName", dir: "asc" }]);
      },
        (error) => {
          this.cedNotificationService.warning("NOTIFICATIONS.GET_CONTACT_INITIATION");
        });
  }

  display() {
    this.isDisplayed = !this.isDisplayed;
  }

  initColumns() {
    if (this.getColumns() == null) {
        this.columns = dossierColumns;
      this.saveColumns();
    }
    else {
      this.columns = JSON.parse(this.getColumns());
    }
  }

  saveColumns() {
    sessionStorage.setItem('columns', JSON.stringify(this.columns));
  }

  getColumns() {
    return sessionStorage.getItem('columns');
  }

  defaultView(){
    this.isDisplayed = false;
    this.columns = null;
    let listComlumns = dossierColumns;
    this.columns =  {
      dossierNumber: true,
      lastName: true,
      maidenName: true,
      firstName: true,
      caseType: true,
      urgency: true,
      country: true,
      location: true,
      diagnose: true,
      birthDate: true,
      createdBy: true,
      creationDate: true,
      status: true,
      helpPlanCount: true,
      clientName: false,
      productName: false,
      alarmCenter: false,
      phoneNumber: false,
      helpPlanNames: false,
      supplierName: false,
      relationNumber: false,
      supplierType: false,
      lastModificationDate: false,
      calamity: false,
      incidentDate: false,
      postalCode: false
    }
    this.saveColumns();
    this.cd.detectChanges();
  }

  hideOnClickOutside(){
    this.isDisplayed = false;
  }

  ngOnDestroy(): void {
    this.sharedService.setSearchFilter(this.state)
    this._subject$.next();
    this._subject$.complete();
  }

}